import {
	getCameraCaptureHeight,
	getVideoCapabilityDebugInfo,
} from '../../../features/base/environment/videoCapability';
import JitsiMeetJS from '../../../features/base/lib-jitsi-meet';
import { createLocalTracks } from '../../../features/base/lib-jitsi-meet/functions.any';
import { getLocalMember, ROLE } from '../../../features/base/members';
import { getPolicy } from '../../../features/base/settings';

class JitsiTracks {
	constructor() {
		this._untoggleScreenSharing = null;
	}

	// 로컬 트랙 생성 (호스트+고사양은 1080, 그 외 720)
	createTracks(options) {
		const local = getLocalMember(APP.store.getState);
		const isHost = local?.role === ROLE.HOST;
		const captureHeight = getCameraCaptureHeight(isHost);

		if (options?.devices?.includes('video')) {
			console.info('[videoQuality] createTracks:', {
				role: local?.role,
				isHost,
				captureHeight,
				...getVideoCapabilityDebugInfo(),
			});
		}

		// 선택된 카메라는 deviceId:{exact} 로 고정한다. lib 는 cameraDeviceId 를 bare(ideal·
		// 비강제) 제약으로 넘기는데, ideal 해상도(1080)와 함께면 브라우저가 해상도를 더 잘
		// 만족하는 다른 카메라(첫번째 1080 지원 캠)로 조용히 바꿔버린다 — 720p 카메라
		// (Logi C270) 선택 시 실증됨. exact 실패 시에만 종전 bare 방식으로 재시도해
		// 장치 유실(뽑힘 등) 상황을 그대로 흡수한다.
		const { cameraDeviceId, ...restOptions } = options || {};
		const buildConstraints = useExact => {
			const video = {
				height: { ideal: captureHeight },
				frameRate: { ideal: 30 },
			};

			if (useExact && cameraDeviceId) video.deviceId = { exact: cameraDeviceId };

			return { video };
		};

		return JitsiMeetJS.createLocalTracks({
			...(cameraDeviceId ? restOptions : options),
			constraints: buildConstraints(true),
		})
			.catch(err => {
				if (!cameraDeviceId) throw err;

				console.warn('[videoQuality] 선택 카메라(exact) 열기 실패 — 기본 선택으로 재시도:', err?.name || err);
				return JitsiMeetJS.createLocalTracks({
					...options,
					constraints: buildConstraints(false),
				});
			})
			.then(([track]) => {
				if (track?.getType?.() === 'video') {
					// 카메라가 실제로 준 해상도 (1080 미지원 카메라면 여기서 낮게 나온다)
					const settings = track.getTrack?.()?.getSettings?.();
					console.info('[videoQuality] 카메라 실제 캡처:', settings?.width, 'x', settings?.height);
				}
				return Promise.resolve(track);
			})
			.catch(err => {
				return Promise.resolve(null);
			});
	}

	createScreenShareTrack(options) {
		const frame = getPolicy(APP.store.getState, 'screen_option')?.frame || 15;

		const getDesktopStreamPromise = options.desktopStream
			? Promise.resolve([options.desktopStream])
			: createLocalTracks(['desktop'], false, {
					desktopSharingSourceDevice: null,
					desktopSharingSources: null,
					resolution: 720,
					minFps: frame,
				});

		return getDesktopStreamPromise.then(
			desktopStreams => {
				this._untoggleScreenSharing = options.unToggleScreenSharing.bind(this);

				desktopStreams &&
					desktopStreams.map(stream => {
						stream.on(JitsiMeetJS.events.track.LOCAL_TRACK_STOPPED, () => {
							this._untoggleScreenSharing && this._untoggleScreenSharing();
						});
					});

				return desktopStreams;
			},
			err => {
				throw err;
			},
		);
	}
}

export default JitsiTracks;
